import type { NextPage } from 'next';
import _ from 'lodash';
import {
	ANewPageComponent,
	ANewPageComponentProps,
	ANewPageStaticProps,
	getStaticPropsNicho
} from 'ui';
import { data, db } from 'data';
import { readItems } from '@directus/sdk';

const ANewPage: NextPage<ANewPageComponentProps> = (props: ANewPageComponentProps) => {
	return <ANewPageComponent {...props} />;
};

type StaticParams = { categoryCode: string; newsCode: string };

export const getStaticProps = getStaticPropsNicho(async (params: StaticParams) => {
	const aNew = await data().news().getANews(params.newsCode);

	return ANewPageStaticProps({
		aNew
	});
});

export async function getStaticPaths() {
	const news = await data().news().getNews();

	const paths = news.map((aNew) => {
		return { params: { categoryCode: aNew.category.code, newsCode: aNew.code } };
	});

	return {
		paths: paths,
		fallback: false // can also be true or 'blocking'
	};
}

export default ANewPage;
